import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import TeamsComponent from '../components/TeamsComponent'

const mapStateToProps = (state) => {
  return {
    teams: state.teams,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamsComponent)
